/* eslint-disable max-lines */
import React from 'react';
import _ from 'lodash';
import { dig } from '@this/src/util/object/object.util';
import { createAITTheme } from '@this/shared/ui/theme';
import type Trip from '@this/domain/trip/trip2';
import { reportError } from '@this/lib/bugsnag';
import OrderItemDescriptionWhenRequestForm from './order_item_description_when_request_form';
import OrderItemsDescription from './order_items_description';
import NonOrderItemsDescription from './non_order_items_description';

interface Props {
  trip: Trip;
  transportVacancies: {
    transportId: number;
    priceDiff: number;
    occupied: boolean;
  }[];
}

const SectionTitle: React.FC = ({ children }) => {
  const theme = createAITTheme();
  const style: React.CSSProperties = {
    marginTop: '40px',
    marginBottom: '5px',
    paddingBottom: '10px',
    borderBottom: `1px solid ${theme.tokens.colors.border.divider}`
  };

  return <h3 style={style}>{children}</h3>;
};

const InAdvanceApplicationTripDetail: React.FC<Props> = ({ trip, transportVacancies }) => {
  try {
    return (
      <section>
        {trip.arrangementRequest ? (
          <>
            <SectionTitle>旅程の詳細</SectionTitle>
            <OrderItemDescriptionWhenRequestForm trip={trip} />
          </>
        ) : (
          <>
            <SectionTitle>旅程の詳細</SectionTitle>
            <OrderItemsDescription trip={trip} transportVacancies={transportVacancies} />
            {!_.isEmpty(dig(trip, 'nonOrderItems')) && (
              <>
                <SectionTitle>経費予定分</SectionTitle>
                <NonOrderItemsDescription trip={trip} />
              </>
            )}
          </>
        )}
      </section>
    );
  } catch (e) {
    reportError(e);
    return null;
  }
};

export default InAdvanceApplicationTripDetail;
